import request from '@/utils/request'

/**
 * 获取业务轨迹列表
 * @param {Object} params 查询参数
 * @returns {Promise} 请求结果
 */
export function listBusinessTableHis(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/businessTableHis.listBusinessTableHis',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 添加业务轨迹
 * @param {Object} data 业务轨迹数据
 * @returns {Promise} 请求结果
 */
export function saveBusinessTableHis(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/businessTableHis.saveBusinessTableHis',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 修改业务轨迹
 * @param {Object} data 业务轨迹数据
 * @returns {Promise} 请求结果
 */
export function updateBusinessTableHis(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/businessTableHis.updateBusinessTableHis',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除业务轨迹
 * @param {Object} data 业务轨迹数据
 * @returns {Promise} 请求结果
 */
export function deleteBusinessTableHis(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/businessTableHis.deleteBusinessTableHis',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}